import { Link } from "react-router-dom";
import { useSEO } from "@/lib/seo";

export default function NotFound() {
  useSEO({ title: "Page Not Found | CJB Clean", description: "This page doesn't exist. Explore CJB Clean's green cleaning services across Northern Virginia, DC & Maryland.", noindex: true });
  return (
    <section className="pt-40 pb-28 max-w-3xl mx-auto px-5 sm:px-8" data-testid="not-found-page">
      <p className="text-xs uppercase tracking-[0.25em] text-leaf mb-4">404</p>
      <h1 className="font-heading text-4xl sm:text-5xl font-bold tracking-tighter text-navy mb-6">We couldn't find that page.</h1>
      <div className="flex flex-wrap gap-3">
        <Link to="/" data-testid="not-found-home-link" className="px-6 py-3 rounded-full bg-leaf text-white font-medium">Go to Home</Link>
        <Link to="/services" data-testid="not-found-services-link" className="px-6 py-3 rounded-full border border-navy/25 text-navy font-medium">View Services</Link>
      </div>
    </section>
  );
}
